export default __webpack_public_path__ + "static/contact-us-bg-efe3afdd104fac541330556fb2eadcda.png";